import templateOne from './templateOne';
import templateTwo from './templateTwo';

export default { templateOne, templateTwo };
